"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var last_1 = __importDefault(require("lodash/last"));
var takeRight_1 = __importDefault(require("lodash/takeRight"));
var mobx_1 = require("mobx");
var constants_1 = __importDefault(require("../core/constants"));
var HISTORY_UP = 'ArrowUp';
var SENT_HISTORY_KEY = "bp::".concat(window.BOT_ID, "::sentHistory");
var ComposerStore = /** @class */ (function () {
    function ComposerStore(rootStore) {
        this.message = '';
        this.locked = false;
        this.hidden = false;
        this._sentHistory = [];
        this._sentHistoryIndex = 0;
        this.rootStore = rootStore;
        if (window.BP_STORAGE) {
            this._sentHistory = window.BP_STORAGE.get(SENT_HISTORY_KEY) || [];
        }
    }
    Object.defineProperty(ComposerStore.prototype, "composerPlaceholder", {
        get: function () {
            var _a;
            return (_a = this.rootStore.config) === null || _a === void 0 ? void 0 : _a.composerPlaceholder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComposerStore.prototype, "composerMaxTextLength", {
        get: function () {
            var _a;
            return (_a = this.rootStore.botInfo) === null || _a === void 0 ? void 0 : _a.maxMessageLength;
        },
        enumerable: false,
        configurable: true
    });
    ComposerStore.prototype.updateMessage = function (msg) {
        this.message = msg;
    };
    ComposerStore.prototype.addMessageToHistory = function (text) {
        var _a;
        if ((0, last_1.default)(this._sentHistory) !== text) {
            this._sentHistory.push(text);
            this._sentHistoryIndex = 0;
            if (this.rootStore.config.enablePersistHistory) {
                (_a = window.BP_STORAGE) === null || _a === void 0 ? void 0 : _a.set(SENT_HISTORY_KEY, (0, takeRight_1.default)(this._sentHistory, constants_1.default.SENT_HISTORY_SIZE));
            }
        }
    };
    ComposerStore.prototype.recallHistory = function (direction) {
        if (!this._sentHistory.length) {
            return;
        }
        var newIndex = direction === HISTORY_UP ? this._sentHistoryIndex - 1 : this._sentHistoryIndex + 1;
        if (newIndex < 0) {
            newIndex = this._sentHistory.length - 1;
        }
        else if (newIndex >= this._sentHistory.length) {
            newIndex = 0;
        }
        this.updateMessage(this._sentHistory[newIndex]);
        this._sentHistoryIndex = newIndex;
    };
    ComposerStore.prototype.setLocked = function (locked) {
        this.locked = !!locked;
    };
    ComposerStore.prototype.setHidden = function (hidden) {
        this.hidden = hidden;
    };
    __decorate([
        mobx_1.observable
    ], ComposerStore.prototype, "message", void 0);
    __decorate([
        mobx_1.observable
    ], ComposerStore.prototype, "locked", void 0);
    __decorate([
        mobx_1.observable
    ], ComposerStore.prototype, "hidden", void 0);
    __decorate([
        mobx_1.observable
    ], ComposerStore.prototype, "_sentHistory", void 0);
    __decorate([
        mobx_1.observable
    ], ComposerStore.prototype, "_sentHistoryIndex", void 0);
    __decorate([
        mobx_1.computed
    ], ComposerStore.prototype, "composerPlaceholder", null);
    __decorate([
        mobx_1.computed
    ], ComposerStore.prototype, "composerMaxTextLength", null);
    __decorate([
        mobx_1.action.bound
    ], ComposerStore.prototype, "updateMessage", null);
    __decorate([
        mobx_1.action.bound
    ], ComposerStore.prototype, "addMessageToHistory", null);
    __decorate([
        mobx_1.action.bound
    ], ComposerStore.prototype, "recallHistory", null);
    __decorate([
        mobx_1.action.bound
    ], ComposerStore.prototype, "setLocked", null);
    __decorate([
        mobx_1.action.bound
    ], ComposerStore.prototype, "setHidden", null);
    return ComposerStore;
}());
exports.default = ComposerStore;
